import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { setCurrentlyOpenFeature } from 'src/modules/App/actions'
import PageTitle from './PageTitle'

const mapStateToProps = state => {
  return {
    isWidgetState: state.appReducer.isWidget,
  }
}

const mapDispatchToProps = {
  setCurrentlyOpenFeature,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageTitle))
